/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { MedicarePrimaryDiagnosis } from './MedicarePrimaryDiagnosis';
import {
    MedicarePrimaryDiagnosisFromJSON,
    MedicarePrimaryDiagnosisFromJSONTyped,
    MedicarePrimaryDiagnosisToJSON,
    MedicarePrimaryDiagnosisToJSONTyped,
} from './MedicarePrimaryDiagnosis';

/**
 * 
 * @export
 * @interface AssessmentFormDiagnosis
 */
export interface AssessmentFormDiagnosis {
    /**
     * 
     */
    primary_diagnosis: MedicarePrimaryDiagnosis;
    /**
     * 
     */
    readonly predicted_primary_diagnosis?: MedicarePrimaryDiagnosis;
    /**
     * 
     */
    readonly predicted_primary_diagnosis_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_primary_diagnosis_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    readonly alternative_diagnosis_1?: MedicarePrimaryDiagnosis;
    /**
     * 
     */
    readonly alternative_diagnosis_1_reasoning?: string | null;
    /**
     * 
     */
    readonly alternative_diagnosis_1_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    readonly alternative_diagnosis_2?: MedicarePrimaryDiagnosis;
    /**
     * 
     */
    readonly alternative_diagnosis_2_reasoning?: string | null;
    /**
     * 
     */
    readonly alternative_diagnosis_2_visual_references?: Array<VisualReference>;
}



/**
 * Check if a given object implements the AssessmentFormDiagnosis interface.
 */
export function instanceOfAssessmentFormDiagnosis(value: object): value is AssessmentFormDiagnosis {
    if (!('primary_diagnosis' in value) || value['primary_diagnosis'] === undefined) return false;
    return true;
}

export function AssessmentFormDiagnosisFromJSON(json: any): AssessmentFormDiagnosis {
    return AssessmentFormDiagnosisFromJSONTyped(json, false);
}

export function AssessmentFormDiagnosisFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentFormDiagnosis {
    if (json == null) {
        return json;
    }
    return {
        
        'primary_diagnosis': MedicarePrimaryDiagnosisFromJSON(json['primary_diagnosis']),
        'predicted_primary_diagnosis': json['predicted_primary_diagnosis'] == null ? undefined : MedicarePrimaryDiagnosisFromJSON(json['predicted_primary_diagnosis']),
        'predicted_primary_diagnosis_reasoning': json['predicted_primary_diagnosis_reasoning'] === undefined ? undefined : json['predicted_primary_diagnosis_reasoning'] === null ? null : json['predicted_primary_diagnosis_reasoning'],
        'predicted_primary_diagnosis_visual_references': json['predicted_primary_diagnosis_visual_references'] == null ? undefined : ((json['predicted_primary_diagnosis_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'alternative_diagnosis_1': json['alternative_diagnosis_1'] == null ? undefined : MedicarePrimaryDiagnosisFromJSON(json['alternative_diagnosis_1']),
        'alternative_diagnosis_1_reasoning': json['alternative_diagnosis_1_reasoning'] === undefined ? undefined : json['alternative_diagnosis_1_reasoning'] === null ? null : json['alternative_diagnosis_1_reasoning'],
        'alternative_diagnosis_1_visual_references': json['alternative_diagnosis_1_visual_references'] == null ? undefined : ((json['alternative_diagnosis_1_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'alternative_diagnosis_2': json['alternative_diagnosis_2'] == null ? undefined : MedicarePrimaryDiagnosisFromJSON(json['alternative_diagnosis_2']),
        'alternative_diagnosis_2_reasoning': json['alternative_diagnosis_2_reasoning'] === undefined ? undefined : json['alternative_diagnosis_2_reasoning'] === null ? null : json['alternative_diagnosis_2_reasoning'],
        'alternative_diagnosis_2_visual_references': json['alternative_diagnosis_2_visual_references'] == null ? undefined : ((json['alternative_diagnosis_2_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function AssessmentFormDiagnosisToJSON(json: any): AssessmentFormDiagnosis {
    return AssessmentFormDiagnosisToJSONTyped(json, false);
}

export function AssessmentFormDiagnosisToJSONTyped(value?: Omit<AssessmentFormDiagnosis, 'predicted_primary_diagnosis'|'predicted_primary_diagnosis_reasoning'|'predicted_primary_diagnosis_visual_references'|'alternative_diagnosis_1'|'alternative_diagnosis_1_reasoning'|'alternative_diagnosis_1_visual_references'|'alternative_diagnosis_2'|'alternative_diagnosis_2_reasoning'|'alternative_diagnosis_2_visual_references'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary_diagnosis': MedicarePrimaryDiagnosisToJSON(value['primary_diagnosis']),
    };
}

